module.exports = __webpack_public_path__ + "img/mobileScreen-infoIcon.070dfb1c.svg";